import React, { useState, useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowRight } from 'react-icons/md';

const NavItem = ({ item, depth = 0 }) => {
    const [openSubmenu, setOpenSubmenu] = useState(false);
    const menuRef = useRef();

    const toggleSubmenu = (e) => {
        if (item.submenus) {
            e.preventDefault();
            setOpenSubmenu(!openSubmenu);
        }
    };

    useEffect(() => {
        const handler = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpenSubmenu(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => {
            document.removeEventListener("mousedown", handler);
        };
    }, []);

    const hasSubmenus = item.submenus && item.submenus.length > 0;

    return (
        <li 
            className={`relative group list-none ${depth === 0 ? 'h-full flex items-center' : 'w-full'} ${item.isButton ? 'ml-auto h-10 text-[#021d53] bg-[#eaeaea] rounded-lg' : ''}`} 
            ref={menuRef}
            onMouseEnter={() => depth === 0 && setOpenSubmenu(true)}
            onMouseLeave={() => depth === 0 && setOpenSubmenu(false)}
        >
            {hasSubmenus ? (
                <button
                    onClick={toggleSubmenu}
                    className={`flex items-center gap-1 py-2 px-3 font-semibold transition-colors duration-200 
                        ${depth === 0 ? 'text-[#021d53] hover:text-[#221b2d]' : 'text-[#021d53] hover:bg-gray-50 w-full text-left'}
                        ${openSubmenu ? 'text-[#221b2d]' : ''}`}
                >
                    {item.name}
                    {depth === 0 ? (
                        <MdOutlineKeyboardArrowDown className={`transition-transform duration-200 ${openSubmenu ? 'rotate-180' : ''}`} />
                    ) : (
                        <MdOutlineKeyboardArrowRight className="ml-auto" />
                    )}
                </button>
            ) : (
                <NavLink
                    to={item.path}
                    className={({ isActive }) => `
                        flex items-center py-2 px-3 font-semibold transition-all duration-200
                        ${depth === 0 ? 'text-[#021d53] hover:text-[#221b2d]' : 'text-[#021d53] hover:bg-gray-100 w-full'}
                        ${isActive && depth === 0 ? 'relative after:content-[""] after:absolute after:bottom-0 after:left-3 after:right-3 after:h-[3px] after:bg-[#221b2d]' : ''}
                        ${isActive && depth > 0 ? 'bg-gray-100 border-l-4 border-[#221b2d]' : ''}
                    `}
                >
                    {item.name}
                </NavLink>
            )}

            {hasSubmenus && (
                <ul 
                    className={`
                        absolute bg-white shadow-xl py-2 min-w-[220px] z-[9999] border-t-4 border-[#221b2d]
                        transition-all duration-300 ease-in-out text-sm
                        ${depth === 0 ? 'top-full left-0' : 'top-0 left-full'}
                        ${openSubmenu ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'}
                    `}
                >
                    {item.submenus.map((submenu, index) => (
                        <NavItem 
                            key={index} 
                            item={submenu} 
                            depth={depth + 1} 
                        />
                    ))}
                </ul>
            )}
        </li>
    );
};

export default NavItem;
